import { ReactElement, ReactNode } from 'react';

import { TooltipProps } from '@mui/material';

type FeatureTooltipItem = {
  title?: string;
  description?: string;
  image?: string;
  link?: string;
  linkTitle?: string;
  placement?: TooltipProps['placement'];
  sendMixpanelEvent?: () => void;
};

type TStarterBannerFeature = {
  icon: ReactNode;
  text: string;
  tooltip?: FeatureTooltipItem;
};

export type TStarterBannerProps = {
  title?: ReactNode;
  description?: string;
  features?: TStarterBannerFeature[];
  isCurrent?: boolean;
  onClick?: () => void;
};

export const PLAN_CATEGORIES = {
  business: 'business',
  creator: 'creator',
  creator_pro: 'creatorPro',
  custom: 'custom',
  enterprise: 'enterprise',
  starter: 'starter',
  trial: 'trial',
} as const;

export type ModalFeatureProps = {
  description: string;
  icon: ReactElement;
};

type MediaType = 'gif' | 'image' | 'video';

export type PlanCategoriesKeys = keyof typeof PLAN_CATEGORIES;
export type PlanCategories = (typeof PLAN_CATEGORIES)[PlanCategoriesKeys];

export type ModalContent = {
  title: string;
  media: {
    videoOptions?: {
      autoPlay: boolean;
      controls: boolean;
      loop: boolean;
    };
    poster?: string;
    src: string;
    type: MediaType;
  };
  bulletsHeader: string;
  buttonText: string;
  caption?: string;
  checkIsSpaceOwner?: boolean;
  features: ModalFeatureProps[];
  mixpanelButtonClickEvent: () => void;
  mixpanelOpeningEvent: () => void;
  subtitle: string;
};

export type LimitedFeatureContent = Partial<Record<PlanCategories, ModalContent | null>>;

export type LimitedFeature =
  | 'aiRewrite'
  | 'audioDownload'
  | 'glossary'
  | 'lipSync'
  | 'multilanguage'
  | 'srtDownload'
  | 'srtUpload'
  | 'teamspace'
  | 'userPrompting'
  | 'videoSubtitles'
  | 'voicePresets';
